import { useAtlases } from './useAtlases';

/** A single atlas by id, derived from the cached useAtlases() list. */
export function useAtlas(id) {
  const { data, isLoading } = useAtlases();
  const atlas = (data || []).find((a) => a.id === id);
  return { data: atlas, isLoading };
}
